import { ScrollingModule } from '@angular/cdk/scrolling';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { LibLoginConfig, LibLoginInterceptor, LibLoginModule } from '@badgertechnologies/liblogin.js';
import {
  AuthorizationService,
  CustomIconService,
  CustomReportsService,
  CustomRouteReuseStrategy,
  DeviceService,
  DialogService,
  ErrorService,
  InsightService,
  MessageService,
  MultiUserRoomService,
  NavigationHistoryService,
  OrganizationGuard,
  OrganizationSelectionService,
  OrganizationService,
  PlayService,
  RobotService,
  RoleGuard,
  StoreService,
  ThemeService,
  TimezoneService,
  TitleService,
  UserService
} from '@ng-cloud/badger-core';
import { provideTranslateService } from '@ngx-translate/core';
import { ActionCableService } from 'angular2-actioncable';
import { HotkeyModule } from 'angular2-hotkeys';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      AppRoutingModule,
      ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-right',
        preventDuplicates: true
      }),
      HotkeyModule.forRoot({ cheatSheetCloseEsc: false }),
      {
        ngModule: LibLoginModule,
        providers: [
          { provide: LibLoginConfig, useValue: { fleet: environment.apiBase, ...environment.keycloak } },
          { provide: HTTP_INTERCEPTORS, useClass: LibLoginInterceptor, multi: true }
        ]
      },
      GoogleMapsModule,
      MatButtonModule,
      MatIconModule,
      MatInputModule,
      MatSortModule,
      MatDatepickerModule,
      MatMomentDateModule
    ),
    ActionCableService,
    AuthorizationService,
    CustomIconService,
    CustomReportsService,
    DeviceService,
    DialogService,
    ErrorService,
    InsightService,
    MessageService,
    MultiUserRoomService,
    OrganizationGuard,
    OrganizationService,
    NavigationHistoryService,
    OrganizationSelectionService,
    PlayService,
    RobotService,
    RoleGuard,
    StoreService,
    TimezoneService,
    ThemeService,
    TitleService,
    UserService,
    DatePipe,
    ScrollingModule,
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideTranslateService({})
  ]
}).catch((error) => console.error(error));
